var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-view',{attrs:{"SingleGetOrderInfoToPay":_vm.SingleGetOrderInfoToPay,"SingleGetOrderPayFeeInfo":_vm.SingleGetOrderPayFeeInfo,"SinglePageOrderPay":_vm.SinglePageOrderPay}})}
var staticRenderFns = []

export { render, staticRenderFns }